module.exports = __webpack_public_path__ + "img/search.6346ba8e.png";